import { CREATE_CONFIGURELIMITREPONSES_FAILURE, CREATE_CONFIGURELIMITREPONSES_REQUEST, CREATE_CONFIGURELIMITREPONSES_SUCCESS } from "../Types";
import { DcOffLineHost } from "../../config";
import { notification } from "antd";

export const ConfigurLimitReponseActions = (formId, setting) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_CONFIGURELIMITREPONSES_REQUEST });

        try {
            const token = localStorage.getItem("token");

            if (!token) {
                throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
            }

            const response = await fetch(`${DcOffLineHost}api/formsettings/${formId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`, 
                },
                body: JSON.stringify(setting),
            });
            
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.message || "Erreur lors de la limite de réponses");
            }
           
            dispatch({ type: CREATE_CONFIGURELIMITREPONSES_SUCCESS, payload: data });

            notification.success({
                message: data?.message || "Réponses limités avec success",
                duration: 5,
            });
            return data;
        } catch (error) {
            dispatch({ type: CREATE_CONFIGURELIMITREPONSES_FAILURE, payload: error?.message });

            notification.error({
                message: error?.message || "Erreur lors de la limite de réponses",
            });
        }
    };
};
